const auth = ({ access_token, created_at, expires_in }) => {
  return {
    auth: {
      accessToken: access_token,
      createdAt: created_at,
      expiresIn: expires_in
    }
  }
}

export default {
  auth
}
